import {Action} from "./action";
import {Renderer} from "./renderer";
import {Test} from "./actions/registers/test";
import {SetRegister} from "./actions/registers/setRegister";
import {IncrementRegister} from "./actions/registers/incrementRegister";
import {Trigger} from "./actions/trigger";

type Actions = {[key: string]: Action}

export class ActionFactory {
    protected actions: Actions = {};

    constructor(protected renderer: Renderer) {
        this.actions.Test = new Test();
        this.actions.SetRegister = new SetRegister();
        this.actions.IncrementRegister = new IncrementRegister();
        this.actions.Trigger = new Trigger();
    }

    public get(type: string): Action | undefined {
        return this.actions[type];
    }
    public getActions(): string[] {
        return Object.keys(this.actions);
    }
}
